import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import { FreeMode } from 'swiper/modules'
import { getEventDetail, getSectionsDetailKeywordVer1 } from '../../api/home'
import { getFilterFestivalList } from '../../api/product'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { BtnHomeModuleMore } from '../../components/Button'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductModal from '../../components/product/ProductModal'
import { SwiperSlideItems, SwiperWraps } from './Festival'
import { FestivalItem } from './FestivalItem'
import { useAppContext } from '../../components/provider/AppProvider'

export default function FestivalManyCollection({ el }: any) {
  const [isTouchMoving, setIsTouchMoving] = useState(false)
  const [sortSectionCategory, setSortSectionCategory] = useState<any>([]) //섹션 카테고리 정렬
  const [selectNumber, setSelectNumber] = useState<number>(0)
  const [categoryLike, setCategoryLike] = useState<boolean>(false) // 카테고리 좋아요
  const [categoryItem, setCategoryItem] = useState<any>([])
  const [selectPath, setSelectPath] = useState<string>('')
  const [selectProductNo, setSelectProductNo] = useState()
  const [type, setType] = useState<any>('') //선택할 카테고리
  const [isModal, setIsModal] = useState<boolean>(false)
  const navigate = useNavigate()
  const { isAppView } = useAppContext()

  const onClickMore = () => {
    const url =
      type === 'section'
        ? `${process.env.REACT_APP_SHOP_URL}/festivalsection?sectionNo=${selectNumber}`
        : `${process.env.REACT_APP_SHOP_URL}${selectPath}`

    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
      })
    } else {
      if (type === 'section') {
        navigate(`/festivalsection`, {
          state: {
            path: '',
            sectionNo: selectNumber,
          },
        })
      } else {
        navigate(selectPath)
      }
    }
  }

  useEffect(() => {
    setSortSectionCategory(el.shopbyFestivalComponentCollections)
    setSelectNumber(el.shopbyFestivalComponentCollections?.[0].no)
    setType(el.shopbyFestivalComponentCollections?.[0].type)
    setSelectPath(el.shopbyFestivalComponentCollections?.[0].path)
  }, [el])

  useEffect(() => {
    const fetchData = async () => {
      if (type === 'exhibition') {
        const res = await getEventDetail(selectNumber, 'ADMIN_SETTING')
        setCategoryItem(res.data.section[0].products)
      } else if (type === 'category') {
        const res = await getFilterFestivalList(selectNumber)
        setCategoryItem(res.data.items)
      } else if (type === 'section' && selectNumber) {
        const { data } = await getSectionsDetailKeywordVer1(selectNumber, 'ADMIN_SETTING')
        setCategoryItem(data.products)
      }
    }

    setTimeout(fetchData, 200)
  }, [type, selectNumber, categoryLike])

  const touchMove = () => {
    setIsTouchMoving(true)
  }

  const touchEnd = () => {
    setIsTouchMoving(false)
  }
  return (
    <>
      <div className='tab_wrap'>
        <SwiperWraps
          slidesPerView={'auto'}
          spaceBetween={4}
          breakpoints={{
            768: {
              spaceBetween: 8,
            },
          }}
          modules={[FreeMode]}
          freeMode={false}
          centeredSlidesBounds={true}
          slideToClickedSlide={true}
          onTouchMove={touchMove}
          onTouchEnd={touchEnd}
        >
          {sortSectionCategory.map((element: any, index: number) => {
            return (
              <SwiperSlideItems key={`${element.no}-${index}`}>
                <div
                  className={Number(element?.no) === Number(selectNumber) ? 'on' : ''}
                  onTouchEnd={() => {
                    if (isMobile && !isTouchMoving) {
                      setSelectNumber(element.no)
                      setType(element.type)
                      setSelectPath(element.path)
                    }
                  }}
                  onClick={() => {
                    if (!isMobile) {
                      setSelectNumber(element.no)
                      setType(element.type)
                      setSelectPath(element.path)
                    }
                  }}
                >
                  <a
                    href='#'
                    onClick={(e) => {
                      e.preventDefault()
                    }}
                  >
                    {element.title}
                  </a>
                </div>
              </SwiperSlideItems>
            )
          })}
        </SwiperWraps>
      </div>

      <div
        className='swiper_wrap home_wrap'
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
          gap: isMobile ? '24px 9px' : '36px 16px',
          alignItems: 'flex-start',
        }}
      >
        {/* 상품 불러오기 */}

        {categoryItem?.map((element: any, index: number) => {
          return (
            <FestivalItem
              key={`${element.no}-${index}`}
              el={element}
              setLike={setCategoryLike}
              setSelectProductNo={setSelectProductNo}
              setIsModal={setIsModal}
            ></FestivalItem>
          )
        })}
      </div>
      {el.hasMoreButton && (
        <div className='btn_area'>
          <BtnHomeModuleMore onClick={onClickMore}>더보기</BtnHomeModuleMore>
        </div>
      )}
      {isModal ? (
        isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            listItem={[]}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={[]}
          ></ProductCenterModal>
        )
      ) : null}
    </>
  )
}
